import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import * as RegistrationReceivedSelectors from '../../../../redux/reducers/registration_received_reducer/selectors';
import { useDispatch } from 'react-redux';
import RegistrationReceiveActions from '../../../../redux/reducers/registration_received_reducer/actions';
import { Box } from '@material-ui/core';
import useStyles from './styles';

interface IProps {
  registration_received_id: number;
}
export default function DatatableList(props: IProps) {
  const result =
    RegistrationReceivedSelectors.useGetFEReceivedByRegisrationReceivedIdList();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column">
      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            RegistrationReceiveActions.fetchFEReceivedByRegistrationReceivedId({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              id: props.registration_received_id,
            })
          );
        }}
      />
    </Box>
  );
}
